<template></template>

<script>
import XLSX from "xlsx";
import dayjs from "dayjs";

const nameData = (row) => ({
    rawData: row,

    ["발주서업로드일자"]: row?.A || "",
    ["관리자메모"]: row?.B || "",
    ["발주처"]: row?.C || "",
    ["상품명"]: row?.D || "",
    ["고객선택옵션"]: row?.E || "",
    ["주문수량"]: row?.F || "",
    ["매입가"]: row?.G || "",
    ["공급사배송비"]: row?.H || "",
    ["주문자명"]: row?.I || "",
    ["주문자연락처"]: row?.J || "",
    ["수령인명"]: row?.K || "",
    ["수령인연락처"]: row?.L || "",
    ["우편번호"]: row?.M || "",
    ["주소"]: row?.N || "",
    ["배송시 요청사항"]: row?.O || "",
    ["택배사**"]: row?.P || "",
    ["배송번호"]: row?.Q || "",
    ["주문번호"]: row?.R || "",
    ["주문상품고유번호"]: row?.S || "",
    ["상품코드"]: row?.T || "",
});

const structureData = ({ rawData, ...data }) => {
    return async ({ getProductByCodeAlt }) => ({
        sender: {
            name: data["주문자명"],
            phone: data["주문자연락처"],
            address: "경기도 안성시 대덕면 모산로 394",
        },

        receiver: {
            name: data["수령인명"],
            phone: data["수령인연락처"],
            postcode: data['우편번호'],
            address1: data["주소"],
            address2: null,
        },

        products: [
            {
                name: data["상품명"],
                codeAlt: data["상품코드"],
                quantity: data["주문수량"],
                ...((await getProductByCodeAlt(data["상품코드"])) || {}),
            },
        ],

        targetsAt: null,

        rawData,
    });
};

export default {
    props: {
        file: { type: File, default: null },
        value: { type: Array, default: () => [] }, // items
        getProductByCodeAlt: { type: Function, default: () => () => {} },
    },
    data: () => ({
        items: [],
    }),
    mounted() {
        this.processFile();
    },
    watch: {
        file() {
            this.processFile();
        },
    },
    methods: {
        processFile() {
            if (this.file) {
                try {
                    this.$emit("loading", true);

                    let reader = new FileReader();
                    reader.onload = async () => {
                        let workBook = XLSX.read(reader.result, { type: "binary" });
                        let workSheets = workBook.SheetNames.map((sheetName) => XLSX.utils.sheet_to_json(workBook.Sheets[sheetName], { range: 1, header: "A" }));
                        this.items = await Promise.all(workSheets[0].map(nameData).map(structureData).map(this.makeData));

                        this.$emit("loading", false);
                        this.$emit("input", this.items);
                    };
                    reader.readAsBinaryString(this.file);
                } catch (error) {}
            }
        },
        async makeData(callback) {
            let { getProductByCodeAlt } = this;
            return callback({ getProductByCodeAlt });
        },
    },
};
</script>

<style>
</style>